'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ResolveState = require('./ResolveState');

var _ResolveState2 = _interopRequireDefault(_ResolveState);

var _PluginMetadata = require('./PluginMetadata');

var _PluginMetadata2 = _interopRequireDefault(_PluginMetadata);

var _PluginConfiguration = require('../PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

var _DependencyConstraint = require('./DependencyConstraint');

var _DependencyConstraint2 = _interopRequireDefault(_DependencyConstraint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 依赖解析算法采用标记法，即假设所有插件均可以解析，然后开始逐遍扫描插件，如果发现插件依赖缺失或者
 * 依赖的插件已经解析失败，则标记该插件解析失败，并且需要再次下一轮扫描直到没有发现解析失败的插件。<br/>
 * 
 * 依赖解析算法描述如下：<br/>
 * （1）插件元数据描述为：pluginMetadata {id, version, 
 *                                    resolvable（可以解析）或者resolveSuccess（如果依赖关系为空，则解析成功）,
 *                                    dependencies = [{id, version}]}
 *     即每一个插件依赖解析元数据为标识、版本、依赖列表；<br/>
 * （2）建立一个插件元数据队列，比如[a, b, c, d, e, f];<br/>
 * （3）定义插件解析失败：依赖插件不存在或者依赖插件解析失败；<br/>
 * （4）从头到位，检查插件，如果插件resolvable，分析插件是否解析失败，如果失败则修改resolveFailed；<br/>
 * （5）重复步骤（4），如果没有再发现resolvable插件解析失败，则转到（6）；<br/>
 * （6）将所有剩下的resolvable插件的状态修改为resolveSuccess。<br/>
 * <br/>
 * 增加一个元素：<br/>
 * （1）元素初始化为：resolvable；<br/>
 * （2）将resolveFailed的元素修改为resolvable；<br/>
 * （3）重新解析。<br/>
 * <br/>
 * 删除一个元素，暂时不考虑，因此插件卸载时，不会直接删除，因为直接删除的话，需要停止掉那些依赖它的插件，过于复杂。<br/>
 * （1）如果该元素为resolveFailed，则直接返回；<br/>
 * （2）如果该元素为resolveSuccess，则需要重新标记并进行全部解析。<br/>
 * 
 * @ignore
 * @export
 * @class PluginResolver
 */
var PluginResolver = function () {

    /**
     * 创建一个插件解析器
     * 
     * @param {PluginConfiguration[]} pluginConfigurations 插件配置集合 
     * @ignore
     * @memberof PluginResolver
     */
    function PluginResolver(pluginConfigurations) {
        (0, _classCallCheck3.default)(this, PluginResolver);

        /**
         * @type {Map.<string, PluginMetadata>}
         */
        this.pluginMetadatas = new _map2.default();

        this.dispose = this.dispose.bind(this);

        this.buildPluginMetadatas = this.buildPluginMetadatas.bind(this);
        this.buildPluginMetadatas(pluginConfigurations);

        this.resolve = this.resolve.bind(this);
        this.findUnsatisfiedConstraints = this.findUnsatisfiedConstraints.bind(this);
        this.markSuccess = this.markSuccess.bind(this);
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.isResolveSuccess = this.isResolveSuccess.bind(this);
        this.getPluginMetadata = this.getPluginMetadata.bind(this);

        this.getDependencies = this.getDependencies.bind(this);
        this.buildAllDependencies = this.buildAllDependencies.bind(this);
        this.buildDependencies = this.buildDependencies.bind(this);

        this.getDependencyChain = this.getDependencyChain.bind(this);
        this.buildDependencyChain = this.buildDependencyChain.bind(this);
        this.buildFirstLevelDependencyChain = this.buildFirstLevelDependencyChain.bind(this);
    }

    /**
     * 清理资源
     * 
     * @memberof PluginResolver
     */


    (0, _createClass3.default)(PluginResolver, [{
        key: 'dispose',
        value: function dispose() {
            this.pluginMetadatas.clear();
        }

        /**
         * 构建插件解析元数据集合。
         * 
         * @param {PluginConfiguration[]} pluginConfigurations 插件配置 
         * @memberof PluginResolver
         */

    }, {
        key: 'buildPluginMetadatas',
        value: function buildPluginMetadatas(pluginConfigurations) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(pluginConfigurations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pluginConfiguration = _step.value;

                    this.pluginMetadatas.set(pluginConfiguration.id, new _PluginMetadata2.default(pluginConfiguration));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * 执行依赖关系解析，支持循环依赖
         * 
         * @memberof PluginResolver
         */

    }, {
        key: 'resolve',
        value: function resolve() {
            var hasFailed = void 0;
            do {
                hasFailed = false; // 初始化状态，如果没有发现有解析失败的，则直接停止，对于正常状态，解析速度非常快
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(this.pluginMetadatas), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var pair = _step2.value;

                        var pluginMetadata = pair[1];
                        if (pluginMetadata.state !== _ResolveState2.default.RESOLVABLE) {
                            continue;
                        }
                        var unsatisfiedConstraints = this.findUnsatisfiedConstraints(pluginMetadata);
                        if (unsatisfiedConstraints.length > 0) {
                            pluginMetadata.markFailed();
                            hasFailed = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } while (hasFailed);

            this.markSuccess();
        }

        /**
         * 查找插件未能够满足的依赖约束
         * 
         * @param {PluginMetadata} pluginMetadata 插件元数据
         * @returns {DependencyConstraint[]} 返回为满足的约束
         * @memberof PluginResolver
         */

    }, {
        key: 'findUnsatisfiedConstraints',
        value: function findUnsatisfiedConstraints(pluginMetadata) {
            var unsatisfiedConstraints = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(pluginMetadata.dependencyConstraints), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var dependencyConstraint = _step3.value;

                    if (!this.pluginMetadatas.has(dependencyConstraint.id)) {
                        dependencyConstraint.markFailed('the dependency[' + dependencyConstraint.id + ', ' + dependencyConstraint.version.versionString + '] of plugin ' + pluginMetadata.id + ' can not be resolved the dependent plugin does not exist');
                        unsatisfiedConstraints.push(dependencyConstraint);
                        continue;
                    }

                    var dependentPluginMetadata = this.pluginMetadatas.get(dependencyConstraint.id);
                    if (dependentPluginMetadata.state === _ResolveState2.default.RESOLVEFAILED) {
                        dependencyConstraint.markFailed('the dependency[' + dependencyConstraint.id + ', ' + dependencyConstraint.version.versionString + '] of plugin ' + pluginMetadata.id + ' can not be resolved the dependent plugin is resolved failed');
                        unsatisfiedConstraints.push(dependencyConstraint);
                        continue;
                    }

                    if (!dependencyConstraint.isSatisfy(dependentPluginMetadata)) {
                        dependencyConstraint.markFailed('the dependency[' + dependencyConstraint.id + ', ' + dependencyConstraint.version.versionString + '] of plugin ' + pluginMetadata.id + ' can not be resolved the dependent plugin exists but the version constraint can not be satisfied');
                        unsatisfiedConstraints.push(dependencyConstraint);
                        continue;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return unsatisfiedConstraints;
        }

        /**
         * 将剩余的可解析插件直接标识为解析成功
         * 
         * @memberof PluginResolver
         */

    }, {
        key: 'markSuccess',
        value: function markSuccess() {
            var needToBuildDependencyPlugins = [];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.pluginMetadatas), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var pair = _step4.value;

                    var pluginMetadata = pair[1];
                    if (pluginMetadata.state !== _ResolveState2.default.RESOLVABLE) {
                        continue;
                    }

                    needToBuildDependencyPlugins.push(pluginMetadata);
                    pluginMetadata.markSuccess();
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            this.buildAllDependencies(needToBuildDependencyPlugins);
        }

        /**
         * 构建所有插件的第一级依赖关系，用于在框架启动时，需要递归启动依赖的插件。
         * 
         * @param {PluginMetadata[]} pluginMetadatas 需要构建的插件元数据集合
         * @memberof PluginResolver
         */

    }, {
        key: 'buildAllDependencies',
        value: function buildAllDependencies(pluginMetadatas) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(pluginMetadatas), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var pluginMetadata = _step5.value;

                    this.buildDependencies(pluginMetadata);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }

        /**
         * 为一个插件构建第一级依赖关系
         * 
         * @param {PluginMetadata} pluginMetadata 需要构建的插件元数据
         * @memberof PluginResolver
         */

    }, {
        key: 'buildDependencies',
        value: function buildDependencies(pluginMetadata) {
            var dependencies = [];

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (0, _getIterator3.default)(pluginMetadata.dependencyConstraints), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var dependencyConstraint = _step6.value;

                    if (pluginMetadata.id === dependencyConstraint.id) {
                        continue;
                    }
                    if (this.existsInPluginMetadatas(dependencies, dependencyConstraint.id)) {
                        continue;
                    }
                    dependencies.push(this.pluginMetadatas.get(dependencyConstraint.id));
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            pluginMetadata.dependencies = dependencies;
        }

        /**
         * 是否已经在依赖中存在
         * 
         * @param {PluginMetadata[]} pluginMetadatas 
         * @param {string} id 
         * @returns {boolean} 如果存在返回true，否则返回false
         * @memberof PluginResolver
         */

    }, {
        key: 'existsInPluginMetadatas',
        value: function existsInPluginMetadatas(pluginMetadatas, id) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = (0, _getIterator3.default)(pluginMetadatas), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var dependencyPluginMetadata = _step7.value;

                    if (id === dependencyPluginMetadata.id) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return false;
        }

        /**
         * 新增一个插件
         * 
         * @param {PluginConfiguration} pluginConfiguration 插件配置 
         * @memberof PluginResolver
         */

    }, {
        key: 'add',
        value: function add(pluginConfiguration) {
            if (this.pluginMetadatas.has(pluginConfiguration.id)) {
                return;
            }

            this.pluginMetadatas.set(pluginConfiguration.id, new _PluginMetadata2.default(pluginConfiguration));
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = (0, _getIterator3.default)(this.pluginMetadatas), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var pair = _step8.value;

                    var pluginMetadata = pair[1];
                    if (pluginMetadata.state === _ResolveState2.default.RESOLVEFAILED) {
                        pluginMetadata.markResolvable();
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            this.resolve();
        }

        /**
         * 注意：插件的卸载只是停止后做一个标记，否则它会引起其它依赖它的插件，该方法不会使用。
         * 如果支持动态卸载插件，则需要将解析失败的插件及其依赖关系动态停止，这非常危险。
         * 
         * @param {PluginConfiguration} pluginConfiguration 
         * @memberof PluginResolver
         */

    }, {
        key: 'remove',
        value: function remove(pluginConfiguration) {
            if (!this.pluginMetadatas.has(pluginConfiguration.id)) {
                return;
            }

            // 如果删除的是解析失败，则不影响其它的插件解析状态，删除后直接返回
            var removedPluginMetadata = this.pluginMetadatas.get(pluginConfiguration.id);
            this.pluginMetadatas.delete(removedPluginMetadata.id);
            if (removedPluginMetadata.state === _ResolveState2.default.RESOLVEFAILED) {
                return;
            }

            // 标记已经解析成功的插件未未解析，因此这些插件可能因为插件删除导致解析失败
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = (0, _getIterator3.default)(this.pluginMetadatas), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var pair = _step9.value;

                    var pluginMetadata = pair[1];
                    if (pluginMetadata.state === _ResolveState2.default.RESOLVESUCCESS) {
                        pluginMetadata.markResolvable();
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            this.resolve();
        }

        /**
         * 判断插件是否已经解析成功
         * 
         * @param {string} id 插件Id
         * @returns {bool} 如果解析成功，则返回true，否则返回false
         * @memberof PluginResolver
         */

    }, {
        key: 'isResolveSuccess',
        value: function isResolveSuccess(id) {
            if (!this.pluginMetadatas.has(id)) {
                return false;
            }

            return this.pluginMetadatas.get(id).state === _ResolveState2.default.RESOLVESUCCESS;
        }

        /**
         * 获取插件解析元数据
         * 
         * @param {string} id 插件Id
         * @returns {PluginMetadata} 插件元数据对象
         * @memberof PluginResolver
         */

    }, {
        key: 'getPluginMetadata',
        value: function getPluginMetadata(id) {
            if (!this.pluginMetadatas.has(id)) {
                return null;
            }

            return this.pluginMetadatas.get(id);
        }

        /**
         * 获取当前插件第一级依赖的插件，不包括递归依赖的插件。
         * 
         * @param {string} id 插件id
         * @returns {PluginMetadata[]} 依赖的第一级插件
         * @memberof PluginResolver
         */

    }, {
        key: 'getDependencies',
        value: function getDependencies(id) {
            if (!this.pluginMetadatas.has(id)) {
                return null;
            }

            return this.pluginMetadatas.get(id).dependencies;
        }

        /**
         * 获取依赖的插件链
         * 
         * @param {string} id 插件Id
         * @returns {PluginMetadata[]} 插件依赖链，最后面为根节点，启动时从最后开始启动
         * @memberof PluginResolver
         */

    }, {
        key: 'getDependencyChain',
        value: function getDependencyChain(id) {
            if (!this.pluginMetadatas.has(id)) {
                return null;
            }

            return this.buildDependencyChain(this.pluginMetadatas.get(id));
        }

        /**
         * 为一个插件构建依赖链
         * 
         * @param {PluginMetadata} pluginMetadata 需要构建的插件元数据
         * @memberof PluginResolver
         */

    }, {
        key: 'buildDependencyChain',
        value: function buildDependencyChain(pluginMetadata) {
            var dependencyChain = [];
            this.buildFirstLevelDependencyChain(pluginMetadata.id, pluginMetadata, dependencyChain);

            var index = 0;
            while (index < dependencyChain.length) {
                var dependentPluginMetadata = dependencyChain[index];
                this.buildFirstLevelDependencyChain(pluginMetadata.id, dependentPluginMetadata, dependencyChain);
                index++;
            }
            return dependencyChain;
        }

        /**
         * 构建第一级别的依赖关系，将其加入到依赖链
         * 
         * @param {string} rootPluginId 需要构建依赖的元素
         * @param {PluginMetadata} dependentPluginMetadata 依赖的插件
         * @param {PluginMetadata[]} dependencyChain 依赖链
         * @memberof PluginResolver
         */

    }, {
        key: 'buildFirstLevelDependencyChain',
        value: function buildFirstLevelDependencyChain(rootPluginId, dependentPluginMetadata, dependencyChain) {
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = (0, _getIterator3.default)(dependentPluginMetadata.dependencyConstraints), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var dependencyConstraint = _step10.value;

                    if (rootPluginId === dependencyConstraint.id) {
                        continue;
                    }
                    if (this.existsInPluginMetadatas(dependencyChain, dependencyConstraint.id)) {
                        continue;
                    }
                    dependencyChain.push(this.pluginMetadatas.get(dependencyConstraint.id));
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }
        }
    }]);
    return PluginResolver;
}();

exports.default = PluginResolver;
//# sourceMappingURL=PluginResolver.js.map